<template>
  <div class="h-content__total">
    <div class="h-content__total-btn" @click="setOrder">Подробнее</div>
  </div>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "DetailOrder",
  props: {
    order: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  methods: {
    ...mapActions(['SET_CURRENT_ORDER']),
    setOrder() {
      this.SET_CURRENT_ORDER(this.order);
    }
  },

}
</script>

<style scoped>

</style>